import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CrmApiService } from '@shared/core';
import { DEFAULT_REQUEST_PARAMS } from '@shared/core/types';
import { CreatePerson, NewPerson, NewPersonResponse } from '@crm/shared/persons/types';

@Injectable({
  providedIn: 'root',
})
export class PersonCreateApiService extends CrmApiService {
  create(person: CreatePerson): Observable<NewPerson> {
    person.brand = person.brand === 'none' ? null : person.brand;

    return this.api
      .post<NewPersonResponse>(`${this.baseEndpoint}persons/`, {
        params: person,
        ...DEFAULT_REQUEST_PARAMS,
      })
      .pipe(
        map(response => response.data),
        catchError((error: HttpErrorResponse) => throwError(error.error)),
      );
  }
}
